
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tech-support/for/[categoryName]",
      function () {
        return require("private-next-pages/tech-support/for/[categoryName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tech-support/for/[categoryName]"])
      });
    }
  